{
    "defaults": {
        "ShorelineCounties": [
            "communitySurvey",
            "coastalEconomy",
            "demographics"
        ],
        "WatershedCounties": [
            "communitySurvey",
            "coastalEconomy",
            "demographics"
        ],
        "CoastalWatershedStates": [
            "coastalEconomy"
        ],
        "ENOW": [
            "oceanEconomy",
            "selfEmployment"
        ],
        "OpenENOW": [
            "openEnow"
        ],
        "CoastalStates": [
            "communitySurvey",
            "coastalEconomy",
            "demographics"
        ],
        "StateCoastal": [
            "communitySurvey",
            "coastalEconomy",
            "demographics"
        ]
    },
    "states": [
        {
            "id": "01000",
            "label": "Alabama"
        },
        {
            "id": "02000",
            "label": "Alaska"
        },
        {
            "id": "06000",
            "label": "California"
        },
        {
            "id": "09000",
            "label": "Connecticut"
        },
        {
            "id": "10000",
            "label": "Delaware"
        },
        {
            "id": "11000",
            "label": "District Of Columbia",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "12000",
            "label": "Florida"
        },
        {
            "id": "13000",
            "label": "Georgia"
        },
        {
            "id": "15000",
            "label": "Hawaii"
        },
        {
            "id": "17000",
            "label": "Illinois"
        },
        {
            "id": "18000",
            "label": "Indiana"
        },
        {
            "id": "22000",
            "label": "Louisiana"
        },
        {
            "id": "23000",
            "label": "Maine"
        },
        {
            "id": "24000",
            "label": "Maryland"
        },
        {
            "id": "25000",
            "label": "Massachusetts"
        },
        {
            "id": "26000",
            "label": "Michigan"
        },
        {
            "id": "27000",
            "label": "Minnesota"
        },
        {
            "id": "28000",
            "label": "Mississippi"
        },
        {
            "id": "33000",
            "label": "New Hampshire"
        },
        {
            "id": "34000",
            "label": "New Jersey"
        },
        {
            "id": "36000",
            "label": "New York"
        },
        {
            "id": "37000",
            "label": "North Carolina"
        },
        {
            "id": "39000",
            "label": "Ohio"
        },
        {
            "id": "41000",
            "label": "Oregon"
        },
        {
            "id": "42000",
            "label": "Pennsylvania"
        },
        {
            "id": "44000",
            "label": "Rhode Island"
        },
        {
            "id": "45000",
            "label": "South Carolina"
        },
        {
            "id": "48000",
            "label": "Texas"
        },
        {
            "id": "51000",
            "label": "Virginia"
        },
        {
            "id": "53000",
            "label": "Washington"
        },
        {
            "id": "55000",
            "label": "Wisconsin"
        },
        {
            "id": "60000",
            "label": "American Samoa",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "66000",
            "label": "Guam",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "69000",
            "label": "Northen Mariana Islands",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "72000",
            "label": "Puerto Rico",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        },
        {
            "id": "78000",
            "label": "Virgin Islands",
            "ENOW": ["oceanEconomy", "selfEmployment"]
        }
    ]
}